import { render, staticRenderFns } from "./Notenpromotionliste.vue?vue&type=template&id=f2d32d22"
import script from "./Notenpromotionliste.vue?vue&type=script&lang=js"
export * from "./Notenpromotionliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports